<body>
  <div class="main-content">
        <div [ngClass]="{
            'background': selectedPalette === 'Billcentrix',
            'background-modern': selectedPalette === 'Moderna',
            'background-violet': selectedPalette === 'Violeta'
          }">
      <app-header></app-header>

      <div class="main-image">
        <div class="text">
          <h1>{{ 'plansPreview.hero.title' | translate }}</h1>
          <p>{{ 'plansPreview.hero.subtitle' | translate }}</p>
        </div>
        <div class="image-right">
          <img src="../../../assets/images/botellasx3-Header.png" alt="imagenes del header">
        </div>
      </div>
    </div>
        <div [ngClass]="{
            'background2': selectedPalette === 'Billcentrix',
            'background2-modern': selectedPalette === 'Moderna',
            'background2-violet': selectedPalette === 'Violeta'
          }">
      <div class="plans">
        <h1>{{ 'plansPreview.plans.ourPlans' | translate }}</h1>
        <p>{{ 'plansPreview.plans.prices' | translate }}</p>
        <div>
          <app-plan-contempo [selectedPalette]="selectedPalette"></app-plan-contempo>
        </div>
      </div>
    </div>
        <div [ngClass]="{
            'banner-content': selectedPalette === 'Billcentrix',
            'banner-content-modern': selectedPalette === 'Moderna',
            'banner-content-violet': selectedPalette === 'Violeta'
          }" >
      <div class="image">
        <img src="../../../assets/images/botellasx3-Header.png" alt="imagen del banner">
      </div>
      <div class="text">
        <h1>{{ 'plansPreview.banner.title' | translate }}</h1>
        <p>{{ 'plansPreview.banner.description' | translate }}</p>
      </div>
    </div>
        <div [ngClass]="{
            'footer': selectedPalette === 'Billcentrix',
            'footer-modern': selectedPalette === 'Moderna',
            'footer-violet': selectedPalette === 'Violeta'
          }" >
      <h2>{{ 'plansPreview.footer.text' | translate }}</h2>
      <hr>
        <div class="mail">
          @if (selectedPalette === 'Billcentrix') {
            <img src="../../../assets/icons/mail.png" alt="icono de mail">
          }
          @if (selectedPalette === 'Moderna') {
            <img src="../../../assets/icons/mail-green.png" alt="icono de mail">
          }
          @if (selectedPalette === 'Violeta') {
            <img src="../../../assets/icons/mail-fucsia.png" alt="icono de mail">
          }
          <h2>Forma&#64;<strong>decontacto.com</strong></h2>
        </div>
      </div>
    </div>
    <!-- <div class="options-buttons">
    <button class="back-btn">Atrás</button>
    <button class="continue-btn">Seleccionar</button>
  </div> -->
</body>